import { useState } from "react";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SearchIcon from "@mui/icons-material/Search";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import FolderIcon from "@mui/icons-material/Folder";
import { 
  TextField, 
  InputAdornment, 
  Box, 
  Typography, 
  Chip,
  Tabs,
  Tab,
  Badge
} from "@mui/material";
import AdminGrid from "../../components/module/admin/AdminGrid/AdminGrid";
import { ADMIN_CONFIGS, CATEGORY_LABELS } from './config/adminConfig';
import PageLayout from "../../components/layout/PageLayout";
import "./administracion.scss";

const Administracion = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<string>("all");

  const adminOptions = Object.entries(ADMIN_CONFIGS).map(([key, config]) => ({
    id: key,
    ...config,
  }));

  const filteredOptions = adminOptions.filter(option => {
    const matchesCategory = selectedCategory === "all" || option.category === selectedCategory;
    const matchesSearch = 
      option.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      option.description.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesCategory && matchesSearch;
  });

  const getCategoryCount = (category: string) => {
    if (category === "all") return adminOptions.length;
    return adminOptions.filter(opt => opt.category === category).length;
  };

  const categoryIcons: Record<string, JSX.Element> = {
    all: <FolderIcon />,
    organizacion: <BusinessIcon />,
    personal: <PeopleIcon />,
    comercial: <ShoppingCartIcon />
  };

  return (
    <PageLayout icon={AdminPanelSettingsIcon} title="Administración">
      <div className="admin-content">
        <div className="admin-header">
          <Box className="header-content">
            <div className="header-info">
              <Typography variant="body2" color="textSecondary" className="header-description">
                Gestiona la configuración empresarial, personal y comercial del sistema
              </Typography>
              <Chip 
                label={`${filteredOptions.length} módulos`}
                size="small"
                color="primary"
                className="modules-count"
              />
            </div>
            <TextField
              placeholder="Buscar módulo..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-field"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </div>

        <Box className="category-tabs">
          <Tabs
            value={selectedCategory}
            onChange={(_, newValue) => setSelectedCategory(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            className="tabs-container"
          >
            <Tab 
              value="all" 
              label={
                <Box className="tab-label">
                  {categoryIcons.all}
                  <span>Todos</span>
                  <Badge 
                    badgeContent={getCategoryCount("all")} 
                    color="primary"
                    className="tab-badge"
                  />
                </Box>
              }
              className="category-tab"
            />
            {Object.entries(CATEGORY_LABELS).map(([key, label]) => (
              <Tab 
                key={key}
                value={key} 
                label={
                  <Box className="tab-label">
                    {categoryIcons[key]}
                    <span>{label}</span>
                    <Badge 
                      badgeContent={getCategoryCount(key)} 
                      color="primary"
                      className="tab-badge"
                    />
                  </Box>
                }
                className="category-tab"
              />
            ))}
          </Tabs>
        </Box>

        {filteredOptions.length > 0 ? (
          <AdminGrid options={filteredOptions} />
        ) : (
          <Box className="no-results">
            <SearchIcon sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
            <Typography variant="h6" color="textSecondary">
              No se encontraron módulos
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Intenta con otros términos de búsqueda o selecciona otra categoría
            </Typography>
          </Box>
        )}
      </div>
    </PageLayout>
  );
};

export default Administracion;